module.exports = __webpack_public_path__ + "static/media/handbags_hero_twitter_card.2c6b18b9.jpg";